import Hero from "@/components/Hero";
import ClientsCarousel from "@/components/ClientsCarousel";
import ImpactSection from "@/components/ImpactSection";
import ServicesTeaser from "@/components/ServicesTeaser";
import TalentsTeaser from "@/components/TalentsTeaser";
import CTASection from "@/components/CTASection";
import { useSite } from "@/context/SiteContext";

export default function HomePage() {
  const { showSection } = useSite();
  return (
    <div data-testid="home-page">
      <Hero />
      <ClientsCarousel />
      <ImpactSection />
      {showSection("nav_show_services") && <ServicesTeaser />}
      {showSection("nav_show_talents") && <TalentsTeaser />}
      {showSection("nav_show_contact") && <CTASection />}
    </div>
  );
}
